<ng-container>
	<obg-m-dialog-layout
		[navbar]="!isDesktop()"
		titleText="{{'verification.title'| translate }}"
		[navbarOptions]="navbarOptions"
	>
		<mat-spinner class="otp" *ngIf="!hasLoaded" diameter="60" />
		<!-- TO BE UPDATED WITH ACTUAL DETAILS LATAM-366 -->
		<account-otp
			phone_extension="90"
			phone_number="15683857491"
			email="pd.testing.qa.11"
			guid="f4d896cb-075b-468d-ae8e-4f09342b6e20"
			(loadingFinished)="loading()"
		/>
	</obg-m-dialog-layout>
</ng-container>
